import { motion } from "framer-motion";
import { X, Bot } from "lucide-react";

/**
 * The little floating pill in the bottom-right that opens the chat.
 */
export default function ChatLauncherButton({ open, onToggle, mascotSrc }) {
  return (
    <motion.button
      onClick={onToggle}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className="group fixed bottom-6 right-6 z-50 flex h-12 items-center gap-2 rounded-full bg-gradient-to-r from-[#7C3AED] via-[#9333EA] to-[#EC4899] py-1 pl-1 pr-4 text-white shadow-xl shadow-purple-600/30 transition-all duration-300 hover:shadow-purple-600/50"
      data-testid="askpurple-toggle-btn"
      aria-label="Open AskPurple"
    >
      {/* Continuous Breathing Ambient Purple Glow Aura */}
      {!open && (
        <motion.span
          animate={{
            boxShadow: [
              "0 0 16px 3px rgba(147, 51, 234, 0.45)",
              "0 0 32px 8px rgba(236, 72, 153, 0.75)",
              "0 0 16px 3px rgba(147, 51, 234, 0.45)",
            ],
          }}
          transition={{
            duration: 2.4,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          className="pointer-events-none absolute inset-0 rounded-full"
        />
      )}

      {/* Outer Glow Halo Layer */}
      {!open && (
        <span className="pointer-events-none absolute -inset-1 rounded-full bg-gradient-to-r from-[#7C3AED]/40 via-[#9333EA]/40 to-[#EC4899]/40 blur-md transition-opacity duration-300 group-hover:blur-lg group-hover:from-[#7C3AED]/60 group-hover:to-[#EC4899]/60" />
      )}
      <div className="relative flex h-10 w-10 items-center justify-center overflow-hidden rounded-full bg-gradient-to-br from-[#FBE6FF] via-[#FFE0F0] to-[#FFE9D5]">
        {open ? (
          <X size={18} className="text-[#7C3AED]" />
        ) : (
          <img
            src={mascotSrc}
            alt="AskPurple"
            draggable={false}
            className="h-full w-full select-none object-cover"
          />
        )}
        {!open && (
          <span className="absolute -bottom-0.5 -right-0.5 h-2.5 w-2.5 rounded-full border-2 border-white bg-emerald-400" />
        )}
      </div>
      <div className="text-left leading-tight">
        <div className="flex items-center gap-1 text-[9px] font-bold uppercase tracking-wider text-white/85">
          <Bot size={10} /> AI Guide
        </div>
        <div className="text-xs font-semibold">{open ? "Close" : "AskPurple"}</div>
      </div>
    </motion.button>
  );
}
